/**
 * Information Scroll Module
 * 5件を超える場合のみスクロールを有効化
 */
export class InformationScroll {
  constructor() {
    this.root = document.querySelector('.l-information');
    if (!this.root) {
      return;
    }

    this.box = this.root.querySelector('.l-information__box');
    this.list = this.root.querySelector('.l-information__list');
    this.items = Array.from(this.list ? this.list.children : []);
    this.visibleCount = 5;
    this.resizeRaf = null;
    this.indicator = null;
    this.indicatorThumb = null;

    if (!this.list || this.items.length === 0) {
      return;
    }

    this.init();
  }

  init() {
    this.createIndicator();
    this.update();

    this._onResize = () => {
      if (this.resizeRaf) {
        cancelAnimationFrame(this.resizeRaf);
      }
      this.resizeRaf = requestAnimationFrame(() => {
        this.update();
      });
    };

    window.addEventListener('resize', this._onResize);
  }

  createIndicator() {
    this.indicator = document.createElement('div');
    this.indicator.className = 'l-information__indicator';

    this.indicatorThumb = document.createElement('span');
    this.indicatorThumb.className = 'l-information__indicator-thumb';
    this.indicator.appendChild(this.indicatorThumb);

    this.box.appendChild(this.indicator);

    this.list.addEventListener('scroll', () => {
      this.updateIndicator();
    });
  }

  update() {
    const shouldScroll = this.items.length > this.visibleCount;

    if (!shouldScroll) {
      this.root.classList.remove('is-scrollable');
      this.indicator.style.display = 'none';
      return;
    }

    this.root.classList.add('is-scrollable');
    this.indicator.style.display = '';
    this.updateIndicator();
  }

  updateIndicator() {
    if (!this.indicatorThumb) {
      return;
    }

    const maxScroll = this.list.scrollHeight - this.list.clientHeight;
    const trackHeight = this.indicator.clientHeight;
    const thumbHeight = trackHeight * 0.2;
    const progress = maxScroll > 0 ? this.list.scrollTop / maxScroll : 0;
    const move = Math.max(0, trackHeight - thumbHeight) * progress;

    this.indicatorThumb.style.top = `${move}px`;
  }

  destroy() {
    window.removeEventListener('resize', this._onResize);
    if (this.resizeRaf) {
      cancelAnimationFrame(this.resizeRaf);
    }
  }
}
